
import { defineComponent, ref } from 'vue';
import AuthWarning from '@/components/AuthWarning.vue';
import IndexedFieldsTable from '@/components/IndexedFieldsTable.vue';
import { useAuth } from '@/plugins/Auth';
import { IndexedField, useContentService } from '@/services/ContentService';
import { FilterMatchMode } from 'primevue/api';

export default defineComponent({
  components: { AuthWarning, IndexedFieldsTable },

  setup() {
    const { configured } = useAuth();
    const { getIndexedFields, indexedFieldsJson } = useContentService();

    const indexedFields = ref<IndexedField[] | undefined>(undefined);
    const filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const multiSortMeta = ref([
      { field: 'shortName', order: 1 },
      { field: 'displayName', order: 1 },
    ]);

    const getFields = async () => {
      indexedFields.value = await getIndexedFields();
    };

    return { configured, indexedFields, indexedFieldsJson, filters, multiSortMeta, getFields };
  },
});
